export default {
  TRANSACTION_DETAILS_LIST_REQUEST: 'APP/TRANSACTION_DETAILS/TRANSACTION_DETAILS_LIST_REQUEST',
  TRANSACTION_DETAILS_LIST_SUCCESS: 'APP/TRANSACTION_DETAILS/TRANSACTION_DETAILS_LIST_SUCCESS',
  TRANSACTION_DETAILS_LIST_ERROR: 'APP/TRANSACTION_DETAILS/TRANSACTION_DETAILS_LIST_ERROR',
};
